import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from 'react-i18next';

export const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { activeRole } = useAuth();
  const { t } = useTranslation();

  return (
    <div style={{ padding: '2rem', maxWidth: '600px', margin: '0 auto' }}>
      <h1>{t('unauthorized.title')}</h1>
      <p>{t('unauthorized.message')}</p>
      <div style={{ marginTop: '1rem', padding: '1rem', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
        <p><strong>{t('unauthorized.debugInfo')}</strong></p>
        <p>{t('unauthorized.activeRole')} {activeRole?.name || 'None'}</p>
        <p>{t('unauthorized.permissions')} {activeRole?.permissions?.length || 0} {t('unauthorized.permissionsLoaded')}</p>
      </div>
      <button 
        onClick={() => navigate('/')} 
        style={{ 
          marginTop: '1rem', 
          padding: '0.5rem 1rem', 
          backgroundColor: '#007bff', 
          color: 'white', 
          border: 'none', 
          borderRadius: '4px', 
          cursor: 'pointer' 
        }}
      >
        {t('unauthorized.goToDashboard')}
      </button>
    </div>
  );
};
